import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import network from './network'
import utils from './utils'
import './plugins/element.js'

Vue.config.productionTip = false

Vue.prototype.$net = network
Vue.prototype.$utils = utils

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')